/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiWebhookHeaderFromJSON, StreemApiWebhookHeaderToJSON, } from './';
export function StreemApiWebhookFromJSON(json) {
    return StreemApiWebhookFromJSONTyped(json, false);
}
export function StreemApiWebhookFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
        'companySid': !exists(json, 'company_sid') ? undefined : json['company_sid'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'method': !exists(json, 'method') ? undefined : json['method'],
        'timeoutMs': !exists(json, 'timeout_ms') ? undefined : json['timeout_ms'],
        'maxAttempts': !exists(json, 'max_attempts') ? undefined : json['max_attempts'],
        'headers': !exists(json, 'headers') ? undefined : (json['headers'].map(StreemApiWebhookHeaderFromJSON)),
    };
}
export function StreemApiWebhookToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sid': value.sid,
        'company_sid': value.companySid,
        'label': value.label,
        'url': value.url,
        'method': value.method,
        'timeout_ms': value.timeoutMs,
        'max_attempts': value.maxAttempts,
        'headers': value.headers === undefined ? undefined : (value.headers.map(StreemApiWebhookHeaderToJSON)),
    };
}
//# sourceMappingURL=StreemApiWebhook.js.map